import { gql } from "@apollo/client";

export interface RewardData {
  gauge: { id: string };
  token: string;
  timestamp: string;
  amount: string;
}

export const GAUGE_QUERY = gql`
  query {
    gauges(first: 10) {
      id
      address
      vault
      removed
    }
    rewards(first: 10) {
      id
      gauge {
        id
      }
      token
      timestamp
      amount
    }
  }
`;

export const GAUGE_REWARD_QUERY = gql`
  query Reward($rewardId: ID!) {
    reward(id: $rewardId) {
      id
      gauge {
        id
      }
      token
      timestamp
      amount
    }
  }
`;